import type { AnyAction } from '@reduxjs/toolkit';
import type { IModuleAction, IToastMessagePrv } from './interface';
import actions from './slice';

function Action(dispatcher: (action: AnyAction) => void): Readonly<IModuleAction> {
    return {
        reset: () => {
            dispatcher(actions.reset());
        },
        updateMessage: (message: Partial<IToastMessagePrv> & { id: string }) => {
            dispatcher(actions.updateMessage(message));
        },
        displayMessage: (message: IToastMessagePrv) => {
            dispatcher(actions.displayMessage(message));
        },
        hideMessage: (message: Partial<IToastMessagePrv> & { id: string }) => {
            dispatcher(actions.hideMessage(message));
        },
    };
}

export default Action;
